import { SchoolData } from "@nimble/candidate-api/types";

export const COVERED_SCHOOL_NO_JOBS_MESSAGE =
  "This school does not currently have any open roles";

export const UNCOVERED_SCHOOL_NO_JOBS_MESSAGE =
  "Please check the school website for current openings";

export function getSchoolNoJobsMessage(
  schoolData: Pick<SchoolData, "district">,
) {
  return schoolData.district.is_covered === false
    ? UNCOVERED_SCHOOL_NO_JOBS_MESSAGE
    : COVERED_SCHOOL_NO_JOBS_MESSAGE;
}
